import React from "react";
import { useNavigate } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="site-footer">
      <div className="footer-content footer-4col">
        <div className="footer-section">
          <div className="footer-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="https://customer-assets.emergentagent.com/job_7c3132cd-0e7d-4761-82eb-f7f5675e5fef/artifacts/uma1p75u_taskerie%20logo%20light.png" alt="taskeri®" style={{ width: 'auto', maxHeight: '48px', objectFit: 'contain', display: 'block' }} />
          </div>
          <p className="footer-tagline">
            On-demand Heroes at your service. Connect, track, and get things done.
          </p>
        </div>

        <div className="footer-section">
          <ul className="footer-links">
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact Us</a></li>
            
            {/* <li><a href="/careers">Careers</a></li> */}
            {/* <li><a href="#">Press</a></li> */}
            {/* <li><a href="#">Blog</a></li> */}
          </ul>
        </div>

        <div className="footer-section">
          <ul className="footer-links">
            <li><a href="/help">Help Center</a></li>
            <li><a href="/safety">Trust & Safety</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Follow us on</h4>
          <div className="footer-social">
            <a href="https://www.facebook.com/taskeri.co/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook" data-testid="footer-social-facebook">
              <Facebook size={20} />
            </a>
            <a href="https://www.instagram.com/taskeri.co" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram" data-testid="footer-social-instagram">
              <Instagram size={20} />
            </a>
            <a href="https://www.tiktok.com/@taskeri.co" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok" data-testid="footer-social-tiktok">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@taskeri" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube" data-testid="footer-social-youtube">
              <Youtube size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div>
            <p>&copy; 2026 taskeri® Technologies Inc. All rights reserved.</p>
            <p style={{fontSize:'0.75em', color:'rgba(255,255,255,0.35)', marginTop:'4px'}}>taskeri<sup style={{fontSize:'0.6em'}}>®</sup> is a registered trademark of taskeri® Technologies Inc.</p>
          </div>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <span className="separator">•</span>
            <a href="/cookie-policy">Cookie Policy</a>
            <span className="separator">•</span>
            <a href="/accessibility">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
